module.exports = __webpack_public_path__ + "img/video-simply-2.1d7fd2ad.png";